/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { Observable, combineLatest, map } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointService } from '../services/breakpoint.service';
import { BottomNavComponent, NavItem } from './bottom-nav/bottom-nav.component';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatSidenavModule,
    NgClass,
    RouterLink,
    RouterLinkActive,
    MatTooltipModule,
    AngularSvgIconModule,
    AsyncPipe,
    TranslatePipe,
    BottomNavComponent,
  ],
})
export class SideMenuComponent implements OnInit {
  canAccessComponent$: Observable<boolean>;
  canAccessProject$: Observable<boolean>;
  canAccessSetting$: Observable<boolean>;
  canAccessGeofence$: Observable<boolean>;
  navItems$: Observable<NavItem[]>;
  readonly bp = inject(BreakpointService);

  constructor(private authService: AuthenticationService) {}

  ngOnInit(): void {
    this.canAccessComponent$ = this.authService.getUserAccessPermissions().pipe(
      map((canAccess) => {
        return (
          !!this.authService.hasValidAccessToken && canAccess.includes('web_app') && canAccess.includes('components')
        );
      })
    );
    this.canAccessProject$ = this.authService.getUserAccessPermissions().pipe(
      map((canAccess) => {
        return (
          !!this.authService.hasValidAccessToken && canAccess.includes('web_app') && canAccess.includes('projects')
        );
      })
    );
    this.canAccessSetting$ = this.authService.getUserAccessPermissions().pipe(
      map((canAccess) => {
        return (
          !!this.authService.hasValidAccessToken && canAccess.includes('web_app') && canAccess.includes('settings')
        );
      })
    );
    this.canAccessGeofence$ = this.authService.getUserAccessPermissions().pipe(
      map((canAccess) => {
        return (
          !!this.authService.hasValidAccessToken && canAccess.includes('web_app') && canAccess.includes('geofence')
        );
      })
    );
    this.navItems$ = combineLatest([this.canAccessComponent$, this.canAccessProject$, this.canAccessSetting$]).pipe(
      map(([components, projects, devices]) => {
        const items: (NavItem & { allowed: boolean })[] = [
          {
            id: 'components',
            route: '/components',
            icon: '/assets/images/icon-48-components.svg',
            labelKey: 'SIDE_MENU.NAV.COMPONENTS',
            allowed: components,
          },
          {
            id: 'projects',
            route: '/projects',
            icon: '/assets/images/icon-48-projects.svg',
            labelKey: 'SIDE_MENU.NAV.PROJECTS',
            allowed: projects,
          },
          {
            id: 'devices',
            route: '/admin/devices',
            icon: '/assets/images/icon-48-sensor.svg',
            labelKey: 'SIDE_MENU.NAV.DEVICES',
            allowed: devices,
          },
        ];
        return items
          .filter((item) => item.allowed)
          .map((item) => ({ id: item.id, route: item.route, icon: item.icon, labelKey: item.labelKey }));
      })
    );
  }

  logout(): void {
    this.authService.logoutCognitoDirect();
  }
}
